import React from "react";
import { Link } from "react-router-dom";

const FeaturedCompanies = ({ companies = [] }) => {
  return (
    <section className="top-companies">
      <div className="auto-container">
        <div className="sec-title text-center">
          <h2>Featured Companies</h2>
          <div className="text">Explore employers currently hiring on Epic-Jobs.</div>
        </div>

        <div className="row">
          {companies.map((company) => (
            <div className="company-block col-lg-4 col-md-6 col-sm-12" key={company.id}>
              <div className="inner-box">
                <figure className="image">
                  {company.logo_url ? (
                    <img src={company.logo_url} alt={company.company_name} />
                  ) : (
                    <span className="company-logo-initials">{company.company_name?.charAt(0) ?? "C"}</span>
                  )}
                </figure>
                <h4>{company.company_name}</h4>
                <div className="location"><i className="flaticon-map-locator"></i> {company.location ?? "Location not added"}</div>
                <Link to={`/jobs?keyword=${encodeURIComponent(company.company_name)}`} className="theme-btn btn-style-three">
                  View Jobs
                </Link>
              </div>
            </div>
          ))}
        </div>

        {companies.length === 0 && (
          <div className="employee-empty-state">No companies available yet.</div>
        )}
      </div>
    </section>
  );
};

export default FeaturedCompanies;
